import { gql } from "@apollo/client";

export const registerMemberMutation = gql`
  mutation RegisterMember($data: CreateMemberInput!) {
    registerMember(data: $data) {
      first_name
      last_name
      email
      location_address
      phone_number
      emergency_contact_name
      emergency_contact_number
      profile
      authId
    }
  }
`;

export const getMemberProfileQuery = gql`
  query GetMyMemberProfile {
    getMyMemberProfile {
      id
      first_name
      last_name
      email
      location_address
      phone_number
      emergency_contact_name
      emergency_contact_number
      distance_travel
      profile
      website
      judgeStatus
      authId
      role
      dateOfJoining
      city
      state
      zipCode
      timezone
    }
  }
`;

export const updateMemberProfileMutation = gql`
  mutation UpdateMyMemberProfile($data: UpdateMemberInput!) {
    updateMyMemberProfile(data: $data) {
      id
      first_name
      last_name
      email
      location_address
      phone_number
      distance_travel
      emergency_contact_name
      emergency_contact_number
      profile
      authId
      city
      state
      zipCode
      timezone
    }
  }
`;

export const updateHostRoleMutation = gql`
  mutation RequestToUpdateRole($authId: String!) {
    requestToUpdateRole(authId: $authId) {
      message
    }
  }
`;

export const deleteDogTrialDetail = gql`
  mutation DeleteDogTrialDetail ($dogTrialId: Int!) {
    deleteDogTrialDetail(dogTrialId: $dogTrialId) {
      message
    }
  }
`;

export const getTrialCalendarEntriesByAuthId = gql`
  query GetTrialCalendarEntriesByAuthId (
    $authId: String!
    $pageNumber: Int!
    $pageSize: Int!
  ) {
    getTrialCalendarEntriesByAuthId(
        pageNumber: $pageNumber
        pageSize: $pageSize
        authId: $authId
    ) {
        pageNumber
        pageSize
        totalDocs
        totalPages
        totalCount
        data {
            dogId
            dog
            trialCalendarId
            trialName
            trialDate
            cutoffDate
            entries {
                id
                division
                elements
            }
        }
    }
  }
`;

export const updateDogTrialDetail = gql`
  mutation UpdateDogTrialDetail(
  $dogTrialId: Int!
  $division: String!
  $elements: String!
) {
  updateDogTrialDetail(
    dogTrialId: $dogTrialId
    data: {
     division: $division
      elements: $elements
    }
  ) {
    message
  }
}

`;
